const books = {
  "gen": {
    "index": 1,
    "testament": "Old",
    "full_name": {
      "en": "Genesis",
      "chs": "创世记",
      "cht": "創世記",
      "alias_chs": "创世纪",
      "alias_cht": "創世紀",
      "pinyin": "csj"
    },
    "short_name": {
      "pinyin": "chuang",
      "en": "Gen",
      "chs": "创",
      "cht": "創"
    }
  },
  "exo": {
    "index": 2,
    "testament": "Old",
    "full_name": {
      "en": "Exodus",
      "chs": "出埃及记",
      "cht": "出埃及記",
      "pinyin": "cajj"
    },
    "short_name": {
      "pinyin": "chu",
      "en": "Exo",
      "chs": "出",
      "cht": "出"
    }
  },
  "lev": {
    "index": 3,
    "testament": "Old",
    "full_name": {
      "en": "Leviticus",
      "chs": "利未记",
      "cht": "利未記",
      "pinyin": "lwj"
    },
    "short_name": {
      "pinyin": "li",
      "en": "Lev",
      "chs": "利",
      "cht": "利"
    }
  },
  "num": {
    "index": 4,
    "testament": "Old",
    "full_name": {
      "en": "Numbers",
      "chs": "民数记",
      "cht": "民數記",
      "pinyin": "msj"
    },
    "short_name": {
      "pinyin": "min",
      "en": "Num",
      "chs": "民",
      "cht": "民"
    }
  },
  "deu": {
    "index": 5,
    "testament": "Old",
    "full_name": {
      "en": "Deuteronomy",
      "chs": "申命记",
      "cht": "申命記",
      "pinyin": "smj"
    },
    "short_name": {
      "pinyin": "shen",
      "en": "Deut",
      "chs": "申",
      "cht": "申"
    }
  },
  "jos": {
    "index": 6,
    "testament": "Old",
    "full_name": {
      "en": "Joshua",
      "chs": "约书亚记",
      "cht": "約書亞記",
      "pinyin": "ysyj"
    },
    "short_name": {
      "pinyin": "shu",
      "en": "Josh",
      "chs": "书",
      "cht": "書"
    }
  },
  "jdg": {
    "index": 7,
    "testament": "Old",
    "full_name": {
      "en": "Judges",
      "chs": "士师记",
      "cht": "士師記",
      "pinyin": "ssj"
    },
    "short_name": {
      "pinyin": "shishi",
      "en": "Judg",
      "chs": "士",
      "cht": "士"
    }
  },
  "rut": {
    "index": 8,
    "testament": "Old",
    "full_name": {
      "en": "Ruth",
      "chs": "路得记",
      "cht": "路得記",
      "pinyin": "ldj"
    },
    "short_name": {
      "pinyin": "de",
      "en": "Ruth",
      "chs": "得",
      "cht": "得"
    }
  },
  "1sa": {
    "index": 9,
    "testament": "Old",
    "full_name": {
      "en": "1 Samuel",
      "chs": "撒母耳记上",
      "cht": "撒母耳記上",
      "pinyin": "smejs"
    },
    "short_name": {
      "pinyin": "sashang",
      "en": "1Sam",
      "chs": "撒上",
      "cht": "撒上"
    }
  },
  "2sa": {
    "index": 10,
    "testament": "Old",
    "full_name": {
      "en": "2 Samuel",
      "chs": "撒母耳记下",
      "cht": "撒母耳記下",
      "pinyin": "smejx"
    },
    "short_name": {
      "pinyin": "saxia",
      "en": "2Sam",
      "chs": "撒下",
      "cht": "撒下"
    }
  },
  "1ki": {
    "index": 11,
    "testament": "Old",
    "full_name": {
      "en": "1 Kings",
      "chs": "列王纪上",
      "cht": "列王紀上",
      "alias_chs": "列王记上",
      "alias_cht": "列王記上",
      "pinyin": "lwjs"
    },
    "short_name": {
      "pinyin": "wangshang",
      "en": "1King",
      "chs": "王上",
      "cht": "王上"
    }
  },
  "2ki": {
    "index": 12,
    "testament": "Old",
    "full_name": {
      "en": "2 Kings",
      "chs": "列王纪下",
      "cht": "列王紀下",
      "alias_chs": "列王记下",
      "alias_cht": "列王記下",
      "pinyin": "lwjx"
    },
    "short_name": {
      "pinyin": "wangxia",
      "en": "2King",
      "chs": "王下",
      "cht": "王下"
    }
  },
  "1ch": {
    "index": 13,
    "testament": "Old",
    "full_name": {
      "en": "1 Chronicles",
      "chs": "历代志上",
      "cht": "歷代志上",
      "pinyin": "ldzs"
    },
    "short_name": {
      "pinyin": "daishang",
      "en": "1Chro",
      "chs": "代上",
      "cht": "代上"
    }
  },
  "2ch": {
    "index": 14,
    "testament": "Old",
    "full_name": {
      "en": "2 Chronicles",
      "chs": "历代志下",
      "cht": "歷代志下",
      "pinyin": "ldzx"
    },
    "short_name": {
      "pinyin": "daixia",
      "en": "2Chro",
      "chs": "代下",
      "cht": "代下"
    }
  },
  "ezr": {
    "index": 15,
    "testament": "Old",
    "full_name": {
      "en": "Ezra",
      "chs": "以斯拉记",
      "cht": "以斯拉記",
      "pinyin": "yslj"
    },
    "short_name": {
      "pinyin": "la",
      "en": "Ezra",
      "chs": "拉",
      "cht": "拉"
    }
  },
  "neh": {
    "index": 16,
    "testament": "Old",
    "full_name": {
      "en": "Nehemiah",
      "chs": "尼希米记",
      "cht": "尼希米記",
      "pinyin": "nxmj"
    },
    "short_name": {
      "pinyin": "ni",
      "en": "Neh",
      "chs": "尼",
      "cht": "尼"
    }
  },
  "est": {
    "index": 17,
    "testament": "Old",
    "full_name": {
      "en": "Esther",
      "chs": "以斯帖记",
      "cht": "以斯帖記",
      "pinyin": "ystj"
    },
    "short_name": {
      "pinyin": "si",
      "en": "Esth",
      "chs": "斯",
      "cht": "斯"
    }
  },
  "job": {
    "index": 18,
    "testament": "Old",
    "full_name": {
      "en": "Job",
      "chs": "约伯记",
      "cht": "約伯記",
      "pinyin": "ybj"
    },
    "short_name": {
      "pinyin": "bo",
      "en": "Job",
      "chs": "伯",
      "cht": "伯"
    }
  },
  "psa": {
    "index": 19,
    "testament": "Old",
    "full_name": {
      "en": "Psalms",
      "chs": "诗篇",
      "cht": "詩篇",
      "pinyin": "sp"
    },
    "short_name": {
      "pinyin": "shi",
      "en": "Psa",
      "chs": "诗",
      "cht": "詩"
    }
  },
  "pro": {
    "index": 20,
    "testament": "Old",
    "full_name": {
      "en": "Proverbs",
      "chs": "箴言",
      "cht": "箴言",
      "pinyin": "zy"
    },
    "short_name": {
      "pinyin": "zhen",
      "en": "Prov",
      "chs": "箴",
      "cht": "箴"
    }
  },
  "ecc": {
    "index": 21,
    "testament": "Old",
    "full_name": {
      "en": "Ecclesiastes",
      "chs": "传道书",
      "cht": "傳道書",
      "pinyin": "cds"
    },
    "short_name": {
      "pinyin": "chuan",
      "en": "Eccl",
      "chs": "传",
      "cht": "傳"
    }
  },
  "sng": {
    "index": 22,
    "testament": "Old",
    "full_name": {
      "en": "Song of Songs",
      "chs": "雅歌",
      "cht": "雅歌",
      "alias_en": "Songs",
      "alias_chs": "雅歌书",
      "alias_cht": "雅歌書",
      "pinyin": "yg"
    },
    "short_name": {
      "pinyin": "ge",
      "en": "Song",
      "chs": "歌",
      "cht": "歌"
    }
  },
  "isa": {
    "index": 23,
    "testament": "Old",
    "full_name": {
      "en": "Isaiah",
      "chs": "以赛亚书",
      "cht": "以賽亞書",
      "pinyin": "ysys"
    },
    "short_name": {
      "pinyin": "sai",
      "en": "Isa",
      "chs": "赛",
      "cht": "賽"
    }
  },
  "jer": {
    "index": 24,
    "testament": "Old",
    "full_name": {
      "en": "Jeremiah",
      "chs": "耶利米书",
      "cht": "耶利米書",
      "pinyin": "ylms"
    },
    "short_name": {
      "pinyin": "ye",
      "en": "Jer",
      "chs": "耶",
      "cht": "耶"
    }
  },
  "lam": {
    "index": 25,
    "testament": "Old",
    "full_name": {
      "en": "Lamentations",
      "chs": "耶利米哀歌",
      "cht": "耶利米哀歌",
      "pinyin": "ylmag"
    },
    "short_name": {
      "pinyin": "ai",
      "en": "Lam",
      "chs": "哀",
      "cht": "哀"
    }
  },
  "ezk": {
    "index": 26,
    "testament": "Old",
    "full_name": {
      "en": "Ezekiel",
      "chs": "以西结书",
      "cht": "以西結書",
      "pinyin": "yxjs"
    },
    "short_name": {
      "pinyin": "jie",
      "en": "Ezek",
      "chs": "结",
      "cht": "結"
    }
  },
  "dan": {
    "index": 27,
    "testament": "Old",
    "full_name": {
      "en": "Daniel",
      "chs": "但以理书",
      "cht": "但以理書",
      "pinyin": "dyls"
    },
    "short_name": {
      "pinyin": "dan",
      "en": "Dan",
      "chs": "但",
      "cht": "但"
    }
  },
  "hos": {
    "index": 28,
    "testament": "Old",
    "full_name": {
      "en": "Hosea",
      "chs": "何西阿书",
      "cht": "何西阿書",
      "pinyin": "hxas"
    },
    "short_name": {
      "pinyin": "he",
      "en": "Hosea",
      "chs": "何",
      "cht": "何"
    }
  },
  "jol": {
    "index": 29,
    "testament": "Old",
    "full_name": {
      "en": "Joel",
      "chs": "约珥书",
      "cht": "約珥書",
      "pinyin": "yes"
    },
    "short_name": {
      "pinyin": "er",
      "en": "Joel",
      "chs": "珥",
      "cht": "珥"
    }
  },
  "amo": {
    "index": 30,
    "testament": "Old",
    "full_name": {
      "en": "Amos",
      "chs": "阿摩司书",
      "cht": "阿摩司書",
      "pinyin": "amss"
    },
    "short_name": {
      "pinyin": "mo",
      "en": "Amos",
      "chs": "摩",
      "cht": "摩"
    }
  },
  "oba": {
    "index": 31,
    "testament": "Old",
    "full_name": {
      "en": "Obadiah",
      "chs": "俄巴底亚书",
      "cht": "俄巴底亞書",
      "pinyin": "ebdys"
    },
    "short_name": {
      "pinyin": "e",
      "en": "Obad",
      "chs": "俄",
      "cht": "俄"
    }
  },
  "jon": {
    "index": 32,
    "testament": "Old",
    "full_name": {
      "en": "Jonah",
      "chs": "约拿书",
      "cht": "約拿書",
      "pinyin": "yns"
    },
    "short_name": {
      "pinyin": "na",
      "en": "Jonah",
      "chs": "拿",
      "cht": "拿"
    }
  },
  "mic": {
    "index": 33,
    "testament": "Old",
    "full_name": {
      "en": "Micah",
      "chs": "弥迦书",
      "cht": "彌迦書",
      "pinyin": "mjs"
    },
    "short_name": {
      "pinyin": "mi",
      "en": "Micah",
      "chs": "弥",
      "cht": "彌"
    }
  },
  "nam": {
    "index": 34,
    "testament": "Old",
    "full_name": {
      "en": "Nahum",
      "chs": "那鸿书",
      "cht": "那鴻書",
      "pinyin": "nhs"
    },
    "short_name": {
      "pinyin": "hong",
      "en": "Nah",
      "chs": "鸿",
      "cht": "鴻"
    }
  },
  "hab": {
    "index": 35,
    "testament": "Old",
    "full_name": {
      "en": "Habakkuk",
      "chs": "哈巴谷书",
      "cht": "哈巴谷書",
      "pinyin": "hbgs"
    },
    "short_name": {
      "pinyin": "ha",
      "en": "Habak",
      "chs": "哈",
      "cht": "哈"
    }
  },
  "zep": {
    "index": 36,
    "testament": "Old",
    "full_name": {
      "en": "Zephaniah",
      "chs": "西番雅书",
      "cht": "西番雅書",
      "pinyin": "xfys"
    },
    "short_name": {
      "pinyin": "fan",
      "en": "Zeph",
      "chs": "番",
      "cht": "番"
    }
  },
  "hag": {
    "index": 37,
    "testament": "Old",
    "full_name": {
      "en": "Haggai",
      "chs": "哈该书",
      "cht": "哈該書",
      "pinyin": "hgs"
    },
    "short_name": {
      "pinyin": "gai",
      "en": "Hagg",
      "chs": "该",
      "cht": "該"
    }
  },
  "zec": {
    "index": 38,
    "testament": "Old",
    "full_name": {
      "en": "Zechariah",
      "chs": "撒迦利亚书",
      "cht": "撒迦利亞書",
      "pinyin": "sjlys"
    },
    "short_name": {
      "pinyin": "sa",
      "en": "Zech",
      "chs": "亚",
      "cht": "亞"
    }
  },
  "mal": {
    "index": 39,
    "testament": "Old",
    "full_name": {
      "en": "Malachi",
      "chs": "玛拉基书",
      "cht": "瑪拉基書",
      "alias_chs": "玛拉基书",
      "alias_cht": "瑪拉基書",
      "pinyin": "mljs"
    },
    "short_name": {
      "pinyin": "ma",
      "en": "Mal",
      "chs": "玛",
      "cht": "瑪"
    }
  },
  "mat": {
    "index": 40,
    "testament": "New",
    "full_name": {
      "en": "Matthew",
      "chs": "马太福音",
      "cht": "馬太福音",
      "alias_chs": "马太",
      "alias_cht": "馬太",
      "pinyin": "mtfy"
    },
    "short_name": {
      "pinyin": "tai",
      "en": "Matt",
      "chs": "太",
      "cht": "太"
    }
  },
  "mrk": {
    "index": 41,
    "testament": "New",
    "full_name": {
      "en": "Mark",
      "chs": "马可福音",
      "cht": "馬可福音",
      "alias_chs": "马可",
      "alias_cht": "馬可",
      "pinyin": "mkfy"
    },
    "short_name": {
      "pinyin": "ke",
      "en": "Mark",
      "chs": "可",
      "cht": "可"
    }
  },
  "luk": {
    "index": 42,
    "testament": "New",
    "full_name": {
      "en": "Luke",
      "chs": "路加福音",
      "cht": "路加福音",
      "alias_chs": "路加",
      "alias_cht": "路加",
      "pinyin": "ljfy"
    },
    "short_name": {
      "pinyin": "lu",
      "en": "Luke",
      "chs": "路",
      "cht": "路",
      "alias_cht": "路"
    }
  },
  "jhn": {
    "index": 43,
    "testament": "New",
    "full_name": {
      "en": "John",
      "chs": "约翰福音",
      "cht": "約翰福音",
      "pinyin": "yhfy"
    },
    "short_name": {
      "pinyin": "yue",
      "en": "John",
      "chs": "约",
      "cht": "約"
    }
  },
  "act": {
    "index": 44,
    "testament": "New",
    "full_name": {
      "en": "Acts",
      "chs": "使徒行传",
      "cht": "使徒行傳",
      "pinyin": "stxz"
    },
    "short_name": {
      "pinyin": "tu",
      "en": "Acts",
      "chs": "徒",
      "cht": "徒"
    }
  },
  "rom": {
    "index": 45,
    "testament": "New",
    "full_name": {
      "en": "Romans",
      "chs": "罗马书",
      "cht": "羅馬書",
      "alias": "羅馬書",
      "pinyin": "lms"
    },
    "short_name": {
      "pinyin": "luo",
      "en": "Rom",
      "chs": "罗",
      "cht": "羅",
      "alias": "羅"
    }
  },
  "1co": {
    "index": 46,
    "testament": "New",
    "full_name": {
      "en": "1 Corinthians",
      "chs": "哥林多前书",
      "cht": "哥林多前書",
      "pinyin": "gldqs"
    },
    "short_name": {
      "pinyin": "linqian",
      "en": "1Cor",
      "chs": "林前",
      "cht": "林前",
      "alias_chs": "哥前"
    }
  },
  "2co": {
    "index": 47,
    "testament": "New",
    "full_name": {
      "en": "2 Corinthians",
      "chs": "哥林多后书",
      "cht": "哥林多後書",
      "pinyin": "gldhs"
    },
    "short_name": {
      "pinyin": "linhou",
      "en": "2Cor",
      "chs": "林后",
      "cht": "林後"
    }
  },
  "gal": {
    "index": 48,
    "testament": "New",
    "full_name": {
      "en": "Galatians",
      "chs": "加拉太书",
      "cht": "加拉太書",
      "pinyin": "jlts"
    },
    "short_name": {
      "pinyin": "jia",
      "en": "Gal",
      "chs": "加",
      "cht": "加"
    }
  },
  "eph": {
    "index": 49,
    "testament": "New",
    "full_name": {
      "en": "Ephesians",
      "chs": "以弗所书",
      "cht": "以弗所書",
      "alias_chs": "以弗所",
      "pinyin": "yfss"
    },
    "short_name": {
      "pinyin": "fu",
      "en": "Eph",
      "chs": "弗",
      "cht": "弗"
    }
  },
  "php": {
    "index": 50,
    "testament": "New",
    "full_name": {
      "en": "Philippians",
      "chs": "腓利比书",
      "cht": "腓利比書",
      "alias_cht": "腓立比書",
      "alias_chs": "腓立比书",
      "pinyin": "flbs"
    },
    "short_name": {
      "pinyin": "fei",
      "en": "Phil",
      "chs": "腓",
      "cht": "腓",
      "alias_chs": "腓立比"
    }
  },
  "col": {
    "index": 51,
    "testament": "New",
    "full_name": {
      "en": "Colossians",
      "chs": "歌罗西书",
      "cht": "歌羅西書",
      "pinyin": "glxs"
    },
    "short_name": {
      "pinyin": "xi",
      "en": "Col",
      "chs": "西",
      "cht": "西"
    }
  },
  "1th": {
    "index": 52,
    "testament": "New",
    "full_name": {
      "en": "1 Thessalonians",
      "chs": "帖撒罗尼迦前书",
      "cht": "帖撒羅尼迦前書",
      "pinyin": "tslnjqs"
    },
    "short_name": {
      "pinyin": "tieqian",
      "en": "1Thes",
      "chs": "帖前",
      "cht": "帖前"
    }
  },
  "2th": {
    "index": 53,
    "testament": "New",
    "full_name": {
      "en": "2 Thessalonians",
      "chs": "帖撒罗尼迦后书",
      "cht": "帖撒羅尼迦後書",
      "pinyin": "tslnjhs"
    },
    "short_name": {
      "pinyin": "tiehou",
      "en": "2Thes",
      "chs": "帖后",
      "cht": "帖後"
    }
  },
  "1ti": {
    "index": 54,
    "testament": "New",
    "full_name": {
      "en": "1 Timothy",
      "chs": "提摩太前书",
      "cht": "提摩太前書",
      "pinyin": "tmtqs"
    },
    "short_name": {
      "pinyin": "tiqian",
      "en": "1Tim",
      "chs": "提前",
      "cht": "提前"
    }
  },
  "2ti": {
    "index": 55,
    "testament": "New",
    "full_name": {
      "en": "2 Timothy",
      "chs": "提摩太后书",
      "cht": "提摩太後書",
      "pinyin": "tmths"
    },
    "short_name": {
      "pinyin": "tihou",
      "en": "2Tim",
      "chs": "提后",
      "cht": "提後"
    }
  },
  "tit": {
    "index": 56,
    "testament": "New",
    "full_name": {
      "en": "Titus",
      "chs": "提多书",
      "cht": "提多書",
      "pinyin": "tds"
    },
    "short_name": {
      "pinyin": "duo",
      "en": "Titus",
      "chs": "多",
      "cht": "多"
    }
  },
  "phm": {
    "index": 57,
    "testament": "New",
    "full_name": {
      "en": "Philemon",
      "chs": "腓利门书",
      "cht": "腓利門書",
      "pinyin": "flms"
    },
    "short_name": {
      "pinyin": "men",
      "en": "Philem",
      "chs": "门",
      "cht": "門"
    }
  },
  "heb": {
    "index": 58,
    "testament": "New",
    "full_name": {
      "en": "Hebrews",
      "chs": "希伯来书",
      "cht": "希伯來書",
      "alias_cht": "希伯來",
      "pinyin": "xbls"
    },
    "short_name": {
      "pinyin": "lai",
      "en": "Heb",
      "chs": "来",
      "cht": "來",
      "alias_cht": "希"
    }
  },
  "jas": {
    "index": 59,
    "testament": "New",
    "full_name": {
      "en": "James",
      "chs": "雅各书",
      "cht": "雅各書",
      "pinyin": "ygs"
    },
    "short_name": {
      "pinyin": "ya",
      "en": "James",
      "chs": "雅",
      "cht": "雅"
    }
  },
  "1pe": {
    "index": 60,
    "testament": "New",
    "full_name": {
      "en": "1 Peter",
      "chs": "彼得前书",
      "cht": "彼得前書",
      "pinyin": "bdqs"
    },
    "short_name": {
      "pinyin": "biqian",
      "en": "1Pet",
      "chs": "彼前",
      "cht": "彼前"
    }
  },
  "2pe": {
    "index": 61,
    "testament": "New",
    "full_name": {
      "en": "2 Peter",
      "chs": "彼得后书",
      "cht": "彼得後書",
      "pinyin": "bdhs"
    },
    "short_name": {
      "pinyin": "bihou",
      "en": "2Pet",
      "chs": "彼后",
      "cht": "彼後"
    }
  },
  "1jn": {
    "index": 62,
    "testament": "New",
    "full_name": {
      "en": "1 John",
      "chs": "约翰一书",
      "cht": "約翰一書",
      "pinyin": "yhys"
    },
    "short_name": {
      "pinyin": "yueyi",
      "en": "1John",
      "chs": "约一",
      "cht": "約一"
    }
  },
  "2jn": {
    "index": 63,
    "testament": "New",
    "full_name": {
      "en": "2 John",
      "chs": "约翰二书",
      "cht": "約翰二書",
      "alias_chs": "约翰ニ书",
      "alias_cht": "約翰ニ書",
      "pinyin": "yhes"
    },
    "short_name": {
      "pinyin": "yueer",
      "en": "2John",
      "chs": "约二",
      "cht": "約二",
      "alias_chs": "约ニ",
      "alias_cht": "約ニ"
    }
  },
  "3jn": {
    "index": 64,
    "testament": "New",
    "full_name": {
      "en": "3 John",
      "chs": "约翰三书",
      "cht": "約翰三書",
      "pinyin": "yhss"
    },
    "short_name": {
      "pinyin": "yuesan",
      "en": "3John",
      "chs": "约三",
      "cht": "約三"
    }
  },
  "jud": {
    "index": 65,
    "testament": "New",
    "full_name": {
      "en": "Jude",
      "chs": "犹大书",
      "cht": "猶大書",
      "pinyin": "yds"
    },
    "short_name": {
      "pinyin": "you",
      "en": "Jude",
      "chs": "犹",
      "cht": "猶"
    }
  },
  "rev": {
    "index": 66,
    "testament": "New",
    "full_name": {
      "en": "Revelation",
      "chs": "启示录",
      "cht": "啟示錄",
      "alias_cht": "啓示錄",
      "pinyin": "qsl"
    },
    "short_name": {
      "pinyin": "qi",
      "en": "Rev",
      "chs": "启",
      "cht": "啟",
      "alias_cht": "啓"
    }
  }
}

export default books;